import { Image, StyleSheet, View } from 'react-native';

import { Button, IconInfo, Text, tokens } from '@fhs/ui';

import { StepsProgress } from '../steps-progress';

import { ChallengeHomeCardProps } from './types';

export function ChallengeHomeCardDesktop(props: ChallengeHomeCardProps) {
  const { image, title, onPressInfo, onPress, buttonText } = props;
  const showProgress = 'progress' in props && props.progress;
  const showBadge = 'badge' in props && props.badge;

  return (
    <View style={styles.container}>
      <Image source={{ uri: image }} style={styles.image} />
      <Text.Heading numberOfLines={1} style={styles.title} type="four">
        {title}
      </Text.Heading>
      <Button onPress={onPressInfo} type="unstyled" style={styles.info}>
        <Button.Icon>
          <IconInfo />
        </Button.Icon>
      </Button>
      {(showBadge || showProgress) && <View style={styles.divider} />}
      {showBadge && (
        <View style={{ marginLeft: 64 }}>
          <View style={styles.badge}>
            <Text.Ui size="sm" weight="semibold" style={{ color: tokens.colors.$white }}>
              {props.badge}
            </Text.Ui>
          </View>
          <Text.Ui size="sm" style={{ marginTop: 12 }}>
            {props.description}
          </Text.Ui>
        </View>
      )}
      {showProgress ? (
        <StepsProgress
          style={styles.progress}
          currentStep={props.progress?.current ?? 0}
          totalSteps={props.progress?.total ?? 0}
        />
      ) : (
        <View style={{ flex: 1 }} />
      )}
      {showProgress && <View style={styles.divider} />}
      {buttonText && (
        <Button onPress={onPress} size="lg" style={styles.button}>
          <Button.Text>{buttonText}</Button.Text>
        </Button>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$white,
    paddingVertical: 24,
    paddingHorizontal: 32,
    marginVertical: 24,
    marginHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  image: {
    width: 64,
    height: 64,
  },
  title: {
    marginLeft: 24,
    flexShrink: 0,
    maxWidth: 300,
  },
  info: {
    marginLeft: 4,
  },
  progress: {
    flex: 1,
    marginLeft: 64,
  },
  divider: {
    height: 32,
    marginLeft: 64,
    borderLeftWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  button: {
    marginLeft: 64,
  },
  badge: {
    alignSelf: 'baseline',
    backgroundColor: tokens.colors.$success,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
  },
});
